import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchAuthMe, fetchPlatformMe } from "../authSlice";
import { proactiveRefreshIfNeeded } from "../../utils/authTokenUtils";

const INIT_TIMEOUT_MS = 12000;

function isPlatformAdminPath() {
  if (typeof window === "undefined") return false;
  return window.location.pathname.startsWith("/admin");
}

export let initialize = createAsyncThunk("initial", async (_, thunkApi) => {
  const timeout = new Promise((resolve) => {
    setTimeout(resolve, INIT_TIMEOUT_MS);
  });

  try {
    await Promise.race([
      (async () => {
        await proactiveRefreshIfNeeded().catch(() => null);
        if (isPlatformAdminPath()) {
          await thunkApi.dispatch(fetchPlatformMe()).unwrap().catch(() => null);
        } else {
          await thunkApi.dispatch(fetchAuthMe()).unwrap().catch(() => null);
        }
      })(),
      timeout,
    ]);
  } finally {
    thunkApi.dispatch(succesInitialized());
  }
  return true;
});

export const initSlice = createSlice({
  name: "init",
  initialState: {
    initialized: false,
  },
  reducers: {
    succesInitialized(state) {
      state.initialized = true;
    },
  },
});

export const { succesInitialized } = initSlice.actions;

export default initSlice.reducer;
